module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAABHNCSVQICAgIfAhkiAAAAOJJREFUOE+tk9sVAUEQRG9lIANCkAEhyAARkAEiQAZkQAZCIAJCkEE7xY63faDP2a+ZvVNdXa2IaAJToE1xrYC+pOP9VUXEBjBoATwcPjEbQBdYSuo9QwKYSxoWCYkIK6lJelBtJYZMJI1LQGq+866d0hADsvb3kvrp0UpKMsgMGNjDBKoMyUAegk0+gz5CIsLmjXJ8SubO8yAdIG9ireyB9a/t7BzSypCISMZeANLxG8gB8NdJefkG4sS+7M5fYr8F6iUW0JH3tNaSPLlruR1vsBfLoKKymfbCntwgRX+VOT8BnQyPWcO+X+kAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/examinatSystem/signoutIcon.png
// module id = Aczd
// module chunks = 3